export default {
  themeBlue: "#22b9ff",
  white: "#fff",
  themeGreen: "#16b272",
  themePurple: "#9F55FF",
  darkGrey: "#a9a9a9",
  red: "#ff3333",
  themeGolden: "#fcb317",
  themeGradient: "linear-gradient(to right, #fcb317, #8bb589, #61b5b3)",
  templateOrange: "#FD7527",
  themeGoldenBtn: {
    marginTop: 18,
    background: "#fcb317",
    color: "#fff",
    width: "100%",
    fontFamily: "Poppins",
    fontWeight: "bolder",
    fontSize: "larger"
  },
  themeGradientBtn: {
    marginTop: 18,
    color: "#fff",
    width: "100%",
    backgroundImage: "linear-gradient(to right, #fcb317, #8bb589, #61b5b3)",
    fontFamily: "Poppins",
    fontWeight: "bolder",
    fontSize: "larger"
  }
};
